/**
 * Authentication error class
 * Extends Error to satisfy linter requirements for throwing error objects
 */
class AuthError extends Error {
    constructor(code, message) {
        super(message);
        this.name = 'AuthError';
        this.code = code;
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AuthError);
        }
    }
}

export { AuthError };
//# sourceMappingURL=auth.js.map
